
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";
import { ContentCategory, ContentFilterState } from "@/types/content-library";

interface ContentLibraryFiltersProps {
  filters: ContentFilterState;
  onChange: (filters: ContentFilterState) => void;
}

const categories: { label: string; value: ContentCategory | 'all' }[] = [
  { label: 'Todos', value: 'all' },
  { label: 'Marketing', value: 'marketing' },
  { label: 'Integração', value: 'integration' },
  { label: 'Cashback', value: 'cashback' },
  { label: 'Indicação', value: 'referral' },
  { label: 'Campanhas', value: 'campaign' },
  { label: 'Analytics', value: 'analytics' },
  { label: 'Configuração', value: 'setup' },
];

const ContentLibraryFilters = ({ filters, onChange }: ContentLibraryFiltersProps) => {
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({
      ...filters,
      searchQuery: e.target.value,
    });
  };

  const handleCategoryChange = (category: ContentCategory | 'all') => {
    onChange({
      ...filters,
      selectedCategory: category,
    });
  };

  return (
    <div className="space-y-4">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 h-4 w-4" />
        <Input 
          placeholder="Buscar conteúdo..." 
          className="pl-9"
          value={filters.searchQuery}
          onChange={handleSearchChange}
        />
      </div>
      <div className="flex flex-wrap gap-2">
        {categories.map((category) => (
          <Button
            key={category.value}
            variant={filters.selectedCategory === category.value ? "default" : "outline"}
            size="sm"
            onClick={() => handleCategoryChange(category.value)}
            className="whitespace-nowrap text-xs sm:text-sm px-2 sm:px-3 py-1 sm:py-2 h-auto"
          >
            {category.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default ContentLibraryFilters;
